<app-search-ui></app-search-ui>
<nb-card>
    <nb-card-body>
      <b>eGlu Ratings :</b>
      <br>
      <br>
      <nb-tabset (changeTab)="onTabChange($event)">
        <nb-tab *ngFor="let feature of features" tabTitle="{{feature}}">
            <div fxLayout="row" fxLayoutAlign = "end center" style="margin-bottom: 10px;">
                <button nbButton status="primary" (click)="exportRatings()" [disabled]="exporting">Export</button>
            </div>
            <nb-card>
                <nb-card-body>
                    <div>
                        <b>Average Rating : {{averageRating.toFixed(2)}}</b>
                        <br>
                        <br>
                        <b>Total Count : {{ratings.length}}</b>
                     </div>
                </nb-card-body>
            </nb-card>
            <!-- <div style="overflow: auto;width: 2000px;">
                <table>
                    <th>Customer Name</th>
                    <th>Email/Phone</th>
                    <th>Rating</th>
                    <th>Liked Most</th>
                    <th>Could be Better</th>
                 <tr *ngFor="let rating of ratings">
                    <td>{{rating.customerName}}</td>
                    <td>{{rating.customerContact}}</td>
                    <td>{{rating.rating}}</td>
                    <td>
                     <ul style="line-height: 2.5em;">
                         <li *ngFor="let like of rating.feedback.likes" style="line-height: 20px;display: inline;background-color: lightgray; margin: 5px;padding: 5px;border-radius: 10px;">
                             {{like}}
                         </li>
                     </ul>
                    </td>
                    <td>{{rating.feedback.dislike}}</td>
                 </tr>
              </table>
            </div> -->
            <nb-card>
                <nb-card-body>
                    <ag-grid-angular
                        style="width: 100%;"
                        class="ag-theme-balham"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        [rowData]="ratings"
                        [rowSelection]="'multiple'"
                        [domLayout]="domLayout"
                        [animateRows]="true"
                        [enableCellTextSelection]=true
                        (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </nb-card-body>
            </nb-card>
            <br>
        </nb-tab>
      </nb-tabset>
    </nb-card-body>
  </nb-card>